<template lang="html">
  <div class="">
    <h1>Settings</h1>

    <label>Your encoded data:</label><br>
    <textarea :value="encodedData"></textarea>
    <br><br>
    <label>Paste encoded data here to overwrite current app data:</label><br>
    <textarea ref="newData"></textarea><br>
    <button @click="replaceData">Replace Data with contents of above.</button>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  computed: {
    journal: function() {
      return this.$root.data.journals[this.$parent.currentJournal]
    },
    encodedData: function() {
      return window.btoa(JSON.stringify(this.$root.data))
    }
  },
  methods: {
    replaceData() {
      if (prompt('Type "YES" in the box to confirm data overwrite.') == "YES") {
        window.localStorage.setItem('journalisr_store', this.$refs.newData.value)
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  background: #e7cfc8;
  padding: 20px;
}
textarea {
  display: block;
  width: 40%;
  /* margin: 0 auto; */
  height: 20%;
}
</style>
